import { ReportEditorPage } from "./ReportEditorPage";

// PR-D: every /reports/:id load now lands on the unified editor page.
// The previous v3.2-vs-v3.1 dispatch (probe the row's GenerationStage,
// route to ReportV32DetailPage when set, ReportViewerPage otherwise)
// is gone — the editor handles both shapes via the row's
// EditedMarkdown / OriginalModelOutput columns plus a "Re-generate to
// enable editing" notice for legacy rows that have neither.
//
// ReportViewerPage is still exported and reachable via the
// /reports/:id/legacy URL (registered in App.tsx) for any saved
// bookmark that depended on the old layout. Candidate for removal in
// a future cleanup.

export function ReportDetailRouter() {
  return <ReportEditorPage />;
}
